import { useEffect, useRef, useState } from "react";
import { serverFetch } from "../../../server";
import { Button, Checkbox, Input, message, Table } from "antd";
import { hasSubstring } from "../../../extensions/helper";
import Ctrl from "./ctrl";
import { RefreshButton } from "../../../extensions/design";
import { useSelector } from "react-redux";

const Ctrls = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState();
  const [filter, setFilter] = useState({ showHidden: false, searchText: "" });
  const divRef = useRef(null);
  const user = useSelector((s) => s.user);

  const getData = () => {
    if (!user?.companyId) return;
    setLoading(true);
    serverFetch(`CompanyCtrl?companyId=${user.companyId}`)
      .then(data => {
        setItems(data);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(getData, [user?.companyId]);

  const columns = [
    { title: "#", dataIndex: "id", width: 100 },
    { title: "Серийный номер", dataIndex: "sn", width: 150 },
    { title: "Название", dataIndex: "name", width: 200 },
    { 
      title: "Вид", 
      dataIndex: "vid", 
      width: 120,
      render: (value) => value === 1 ? "Z5rnet" : "Unknown"
    },
    { 
      title: "Время ожидания (сек)", 
      dataIndex: "deadlineSec",
      width: 150,
      align: "right"
    },
    { 
      title: "Вид кода карты", 
      dataIndex: "cardType",
      width: 150,
      render: (value) => {
        if (value === 1) return "XXXXXX123456 -> 123456";
        return "Без кодирования";
      }
    },
    { title: "Версия прошивки", dataIndex: "fw" },
    { 
      title: "Последняя синхронизация", 
      dataIndex: "lastSync",
      width: 180,
      render: (value) => value ? new Date(value).toLocaleString("ru-RU") : "-"
    },
    { 
      title: "IP синхронизации", 
      dataIndex: "ipSync",
      width: 150
    },
    { 
      title: "Акт", 
      dataIndex: "active", 
      width: 48, 
      align: "center", 
      render: value => <Checkbox checked={value} disabled /> 
    },
  ]

  const onClose = (refresh) => {
    setEditId();
    refresh && getData();
  }

  const divItem = editId != null && <Ctrl id={editId} onClose={onClose} companyId={user?.companyId} />
  const headerSize = divRef.current?.querySelector('.ant-table-thead')?.offsetHeight ?? 0;
  const tableHeight = divRef.current ? (document.documentElement.offsetHeight - headerSize - divRef.current.getBoundingClientRect().top - window.scrollY) : 0;
  const tableWidth = (document.documentElement.offsetWidth - divRef.current?.getBoundingClientRect().left) || 0;

  const onChangeFilter = value => setFilter({ ...filter, ...value });

  const filtered = items.filter(item => {
    if (!filter.showHidden && !item.active) return false;
    if (!hasSubstring(filter.searchText, item.name) && !hasSubstring(filter.searchText, item.sn)) return false;
    return true;
  })

  return <div>
    <div className="sport-form-title">
      <Checkbox checked={filter.showHidden} onChange={e => onChangeFilter({ showHidden: e.target.checked })}>Показывать неактивные</Checkbox>
      <Input placeholder="Поиск" value={filter.searchText} onChange={e => onChangeFilter({ searchText: e.target.value })} />
      <RefreshButton onClick={getData} />
    </div>
    <div ref={divRef} style={{ width: tableWidth }}>
      <Table
        dataSource={filtered}
        columns={columns}
        rowKey="id"
        loading={loading}
        size="small"
        pagination={false}
        scroll={{ y: tableHeight }}
        rowSelection={{ type: 'radio', selectedRowKeys: [editId], renderCell: checked => <div className={checked ? "list-indicator" : ""} /> }}
        onRow={(record) => ({ onClick: () => { setEditId(record.id) } })}
      />
    </div>
    {divItem}
  </div>
}

export default Ctrls;

